import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { AuthHelper } from "src/helper/auth-helper";
import { CommonApiService } from "src/helper/common-api.service";
import { MessageService } from "src/helper/message.service";

@Injectable()
export class AdminService {
  constructor(private commonApiService: CommonApiService, private messageService: MessageService) { }
  private Userdata: any;

  public get getuserdata(): any {
    return this.Userdata;
  }

  public setUser(data: any) {
    this.Userdata = data;
  }

  private sharedObj = new Subject<any>();

  certificateCreate(user: any) {
    this.sharedObj.next(user);
  }

  public retrieveMappedObject(): Observable<any> {
    return this.sharedObj.asObservable();
  }

  ForgotPassword(params: any) {
    return new Promise((resolve, reject) => {
      this.commonApiService.getPromiseResponse({ apiName: '/api/forgotpassword', methodType: 'post', parameterObject: params }).then(result => {
        resolve(result);
      }).catch(error => {
        this.messageService.warningMessage(error)
        reject(error);
      })
    })
  }

  getProfile(id: any) {
    return new Promise(async (resolve, reject) => {
      await this.commonApiService.getPromiseResponse({ apiName: '/api/' + id, methodType: 'get' }).then(result => {
        this.setUser(result)
        resolve(result);
      }).catch(error => {
        this.messageService.warningMessage(error)
        reject(error);
      })
    })
  }



  updatestage(params: any) {
    return new Promise((resolve, reject) => {
      this.commonApiService.getPromiseResponse({ apiName: '/api/user/update/' + AuthHelper.UserDetails.AccountId, methodType: 'put', parameterObject: params }).then(result => {
        resolve(result);
      }).catch(error => {
        if (error.message) {
          this.messageService.warningMessage(error.message)
        }
        reject(error);
      })
    })
  }


  ConfirmCode(params: any) {
    return new Promise((resolve, reject) => {
      this.commonApiService.getPromiseResponse({ apiName: '/api/confirmcode', methodType: 'post', parameterObject: params }).then(result => {
        resolve(result);
      }).catch(error => {
        if (error.message) {
          this.messageService.warningMessage(error.message)
        }
        reject(error);
      })
    })
  }

  SetPassword(params: any) {
    return new Promise((resolve, reject) => {
      this.commonApiService.getPromiseResponse({ apiName: '/api/setpassword', methodType: 'post', parameterObject: params }).then(result => {
        resolve(result);
      }).catch(error => {
        if (error.message) {
          this.messageService.warningMessage(error.message)
        }
        reject(error);
      })
    })
  }

  Register(params: any) {
    return new Promise((resolve, reject) => {
      this.commonApiService.getPromiseResponse({ apiName: '/api/register', methodType: 'post', parameterObject: params }).then(result => {
        resolve(result);
      }).catch(error => {
        if (error.message) {
          this.messageService.warningMessage(error.message)
        }
        reject(error);
      })
    })
  }

  ContactUs(params: any) {
    return new Promise((resolve, reject) => {
      this.commonApiService.getPromiseResponse({ apiName: '/api/contact', methodType: 'post', parameterObject: params }).then(result => {
        resolve(result);
      }).catch(error => {
        if (error.message) {
          this.messageService.warningMessage(error.message)
        }
        reject(error);
      })
    })
  }

  AuthRefreshToken(params: any) {
    return new Promise((resolve, reject) => {
      this.commonApiService
        .getPromiseResponse({
          apiName: 'auth/refresh_token',
          methodType: 'Post',
          parameterObject: params
        })
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          if (error.message) {
            this.messageService.warningMessage(error.message);
          }
          reject(error);
        });
    });
  }

  getIsEnroll(user_id: any, course_id: any) {
    return new Promise(async (resolve, reject) => {
      await this.commonApiService.getPromiseResponse({ apiName: '/api/user/' + user_id + '/course/' + course_id, methodType: 'get' }).then(result => {
        this.setUser(result)
        resolve(result);
      }).catch(error => {
        this.messageService.warningMessage(error)
        reject(error);
      })
    })
  }

  getnewToken(user_id: any) {
    return new Promise(async (resolve, reject) => {
      await this.commonApiService.getPromiseResponse({ apiName: '/api/user/' + user_id + '/rtoken', methodType: 'get' }).then(result => {
        this.setUser(result)
        resolve(result);
      }).catch(error => {
        this.messageService.warningMessage(error)
        reject(error);
      })
    })
  }

  FileUpload(params: any) {
    return new Promise((resolve, reject) => {
      this.commonApiService
        .getPromiseResponse({
          apiName: '/api/file_upload',
          methodType: 'post',
          parameterObject: params,
        })
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {

          if (error.message) {
            this.messageService.warningMessage(error.message);
          }
          reject(error);
        });
    });
  }
}